// Keep Vite development uncached; service workers run only in production builds.
if (import.meta.env.PROD && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(error => {
      console.warn('Raydius offline support unavailable:', error);
    });
  }, { once: true });
}
